import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";

export const getProductList = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.PRODUCT.GET_PRODUCT_LIST,
    { params: params }
  );
  console.log('response.data------------------------Product>',response.data);
  return response.data;
};

export const getSingleProductData = async (id?:number,params?: Record<string, any>) => {
  const response = await axiosInstance.get(
   `${API_ENDPOINTS.PRODUCT.GET_SINGLE_PRODUCT_BY_ID}/${id}`
  );
  return response.data;
};

export const getBrandData = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
   API_ENDPOINTS.PRODUCT.GET_BRANDS,{params:params}
  );
  return response.data;
};


export const getCategoryData = async (params?: Record<string, any>) => {

 
  const response = await axiosInstance.get(
   API_ENDPOINTS.PRODUCT.GET_CATEGORY_LIST,{params:params}
  );
  return response.data;
};

export const getTagsData = async (params?: Record<string, any>) => {

 
  const response = await axiosInstance.get(
   API_ENDPOINTS.PRODUCT.GET_TAG_LIST
  );
  return response.data;
};

export const getPackagingData = async (params?: Record<string, any>) => {

 
  const response = await axiosInstance.get(
   API_ENDPOINTS.PRODUCT.GET_PACKAGE_LIST
  );
  return response.data;
};


export const addProduct = async (reqBody:any) => {
    let response = await axiosInstance.post(`${API_ENDPOINTS.PRODUCT.ADD_PRODUCT}`, reqBody );
    return response.data;
}

export const updateProduct = async (reqBody:any,id:number) => {
    let response = await axiosInstance.put(`${API_ENDPOINTS.PRODUCT.UPDATE_PRODUCT}/${id}`, reqBody );
    return response.data;
}

export const getBrandCompetition = async (params:Record<string,any>,id:number) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.PRODUCT.GET_BRAND_COMPETITION_LIST}/${id}`, {params} );
    return response.data;
}

export const getSingleBrandCompetition = async (params:Record<string,any>,id:number) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.PRODUCT.GET_SINGLE_BRAND_COMPETITOR}/${id}`, {params} );
    return response.data;
}

export const addBrandCompetition = async (reqBody:any) => {
    let response = await axiosInstance.post(`${API_ENDPOINTS.PRODUCT.ADD_BRAND_COMPETITOR}`, reqBody );
    return response.data;
}

export const updateBrandCompetition = async (reqBody:any,id:number) => {
    let response = await axiosInstance.put(`${API_ENDPOINTS.PRODUCT.UPDATE_BRAND_COMPETITOR}/${id}`, reqBody );
    return response.data;
}